import env from '../../../env';
import BaseService from '../../../services/BaseService';

let url = `${env.health_backend}health/alumni`;

class AlumniService extends BaseService {}

export default new AlumniService('health_backend', 'org/alumni');